var map = {
	"./table-img-1.png": 3496,
	"./table-img-2.png": 3497,
	"./table-img-3.png": 3498,
	"./table-img-4.png": 3499,
	"./table-img-5.png": 3500,
	"./table-img-6.png": 3501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3495;